import { render, staticRenderFns } from "./CompetitionFilterLink.vue?vue&type=template&id=3f6683f0&scoped=true&"
import script from "./CompetitionFilterLink.vue?vue&type=script&lang=js&"
export * from "./CompetitionFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6683f0",
  null
  
)

export default component.exports